import { LegalDocumentMetadata, LegalSection } from '../models/legal-documents-metadata';

export function getMetadataBySection(legalDocumentMetadata: LegalDocumentMetadata[], section: LegalSection) {
  return legalDocumentMetadata.filter((metadata) => metadata.section === section);
}
